export const SET_PHOTOS = 'SET_PHOTOS'
export const SET_PHOTO = 'SET_PHOTO'
